import { verifyPinCode } from 'widgets/RequestAdminLocalPW/Callback';
import ModalCashDeposit, { useModalCashDepositRef } from './ModalCashDeposit';
import Button from 'components/Button';
export const useCashierCashDeposit = (): [() => void, JSX.Element] => {
  const modalRef = useModalCashDepositRef();
  const handleOpen = () => verifyPinCode((_pin, staffValue) => {
    const staffId = staffValue?.id?.toString() || '';
    if (!staffId) return;
    modalRef.current?.open(staffId
    );
  });
  const context = <ModalCashDeposit ref={modalRef} />;
  return [handleOpen, context];
};
const CashierCashDeposit = () => {
  const modalRef = useModalCashDepositRef();
  const handleOpen = () => verifyPinCode((_pin, staffValue) => {
    const staffId = staffValue?.id?.toString() || '';
    if (!staffId) return;
    modalRef.current?.open(staffId);
  });
  return (
    <>
      <Button ntype='DANGER' onClick={handleOpen}>Open</Button>
      <ModalCashDeposit ref={modalRef} />
    </>
  );
};

export default CashierCashDeposit;
